module.exports = __webpack_public_path__ + "img/login-chillogallo.88c86d0b.svg";